import React from "react";
import "./HowItWorks.scss";
//

import inviteFrnd from "../../../../utilities/images/refer&earn/inviteFrnd.png";
import friendPurchaseImg from "../../../../utilities/images/refer&earn/yourFrndWillPrchs.png";
import motionCoinsImg from "../../../../utilities/images/refer&earn/youAndYourFrndGetMotionCoins.png";
import dottedLineImg from "../../../../utilities/images/refer&earn/dottedImg.png";

const HowItWorks = ({ works }) => {
  console.log("worksworkds", works);
  //   const workDescriptions = Object.values(works);
  return (
    <div className="howItWorksContainer">
      <div className="howItWorksTitle">How It Works?</div>
      <div className="howItWorksContent">
        <div className="howItWorksImages">
          <img src={inviteFrnd} alt="Invite a Friend" />
          <img className="dottedLine" src={dottedLineImg} alt="Dotted Line" />
          <img src={friendPurchaseImg} alt="Friend's Purchase" />
          <img className="dottedLine" src={dottedLineImg} alt="Dotted Line" />
          <img src={motionCoinsImg} alt="Earn Motion Coins" />
        </div>
        <div className="howItWorksSteps">
          {works &&
            Object.values(works).map((description, index) => (
              <div className="howItWorksStep" key={index}>
                {description}
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};

export default HowItWorks;
